import React, { useEffect, useState } from "react";
import { fetchNewCategories, addNewCategory } from "../services/api";
import { v4 as uuidv4 } from "uuid";
import "./PageLayout.css";

function NewCategoryPage() {
  const [categories, setCategories] = useState([]); // ✅ Ensure `categories` is an array

  const [form, setForm] = useState({
    Id: "",
    Name: "",
    ParentCategoryId: "",
    Priority: "",
  });

  // ✅ Load categories on component mount
  useEffect(() => {
    const loadCategories = async () => {
      try {
        const fetchedCategories = await fetchNewCategories();
        console.log("✅ Loaded Categories:", fetchedCategories);
        setCategories(fetchedCategories || []); // ✅ Ensure it's an array
      } catch (error) {
        console.error("❌ Error fetching categories:", error);
        setCategories([]); // ✅ Prevent errors
      }
    };
    loadCategories();
  }, []);

  // ✅ Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ✅ Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.Id.trim() || !form.Name.trim()) {
        alert("❌ ID and Category Name are required.");
        return;
    }

    const formattedData = {
        id: form.Id.trim(),
        name: form.Name.trim(),
        parentCategoryId: form.ParentCategoryId || null,
        priority: form.Priority ? parseInt(form.Priority, 10) : 1,
        derivativeSystemId: "vquest"  // ✅ Ensure this is always included
    };

    console.log("📤 Sending Data to API:", formattedData);  // ✅ Debugging

    try {
        await addNewCategory(formattedData);
        alert("✅ New Category Added!");

        // ✅ Reset the form
        setForm({
            Id: "",
            Name: "",
            ParentCategoryId: "",
            Priority: "",
        });

        // ✅ Reload categories
        const updatedCategories = await fetchNewCategories();
        setCategories(updatedCategories || []);
    } catch (error) {
        console.error("❌ Error saving category:", error.response?.data || error);
    }
};




  return (
    <div className="category-page">
      <h1>Add New Category</h1>

      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="hidden"
              name="DerivativeSystemId"
              value={"vquest"}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="input-group">
            <label>ID</label>
            <input
              type="text"
              name="Id"
              value={form.Id}
              onChange={handleInputChange}
              required
              placeholder="Enter unique ID"
            />
          </div>

          <div className="input-group">
            <label>Category Name</label>
            <input
              type="text"
              name="Name"
              value={form.Name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="input-group">
            <label>Parent Category (Optional)</label>
            <select
              name="ParentCategoryId"
              value={form.ParentCategoryId}
              onChange={handleInputChange}
            >
              <option value="">No Parent (Top-Level)</option>
              {categories.length > 0 ? (
                categories.map((cat) => (
                  <option key={cat.Id} value={cat.Id}>
                    {cat.Name}
                  </option>
                ))
              ) : (
                <option disabled>Loading categories...</option>
              )}
            </select>
          </div>

          <div className="input-group">
            <label>Priority</label>
            <input
              type="number"
              name="Priority"
              value={form.Priority}
              onChange={handleInputChange}
              min="1"
              placeholder="Set priority order"
            />
          </div>

          <button type="submit">Add Category</button>
        </form>
      </div>

      <div className="category-list">
        <h2>Existing Categories</h2>
        {categories.length === 0 ? (
          <p>Loading categories...</p>
        ) : (
          <ul>
            {categories.map((cat) => (
              <li key={cat.Id}>
                {cat.Name} {cat.ParentCategoryId ? `(Sub-Category of ${cat.ParentCategoryId})` : ""}
                <span className="priority-badge">Priority: {cat.Priority || 1}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default NewCategoryPage;
